import { jsx as s } from "react/jsx-runtime";
import { forwardRef as L, useState as P, useRef as O, useImperativeHandle as R, useCallback as S, useEffect as E } from "react";
import { useResize as _ } from "../../hooks/useResize.es.js";
import { Tooltip as b } from "../Tooltip/Tooltip.es.js";
import { chakra as x, useStyleConfig as H } from "@chakra-ui/react";
const B = {
  Regular: "normal",
  Medium: "medium"
}, C = {
  Disabled: "disabled"
}, D = {
  LG: "lg",
  MD: "md",
  SM: "sm",
  XS: "xs"
}, I = L(
  ({ as: c = "p", enableTooltip: a = !1, fontWeight: n = "normal", size: l = "lg", variant: f, ...e }, u) => {
    const [m, d] = P(!1), t = x[c], r = O(null);
    R(u, () => r.current);
    const i = S(() => {
      if (r.current && e.noOfLines && a) {
        const { scrollHeight: g = 0, clientHeight: h = 0 } = r.current;
        d(
          !!(e.noOfLines && a && g > h)
        );
      }
    }, [e.noOfLines, a, r.current]);
    _(() => i(), {
      enabled: !!(e.noOfLines && a)
    });
    const o = H("Paragraph", {
      size: l,
      variant: f
    });
    return E(() => {
      i();
    }, [e.noOfLines, a, r.current]), a && m ? /* @__PURE__ */ s(b, { label: e.children, children: /* @__PURE__ */ s(t, { ref: r, __css: o, fontWeight: n, ...e }) }) : /* @__PURE__ */ s(t, { ref: r, __css: o, fontWeight: n, ...e });
  }
);
export {
  I as Paragraph,
  D as ParagraphSizes,
  C as ParagraphVariants,
  B as ParagraphWeights
};
//# sourceMappingURL=Paragraph.es.js.map
